import _regeneratorRuntime from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useCallback, useState } from 'react';
import { useNotificationsContext, useTransactionsContext } from '../providers';
import { errors } from 'ethers';

var isDroppedAndReplaced = function isDroppedAndReplaced(e) {
  return (e === null || e === void 0 ? void 0 : e.code) === errors.TRANSACTION_REPLACED && (e === null || e === void 0 ? void 0 : e.replacement) && ((e === null || e === void 0 ? void 0 : e.reason) === 'repriced' || (e === null || e === void 0 ? void 0 : e.cancelled) === false);
};

export function usePromiseTransaction(chainId, options) {
  var _useState = useState({
    status: 'None'
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var _useTransactionsConte = useTransactionsContext(),
      addTransaction = _useTransactionsConte.addTransaction;

  var _useNotificationsCont = useNotificationsContext(),
      addNotification = _useNotificationsCont.addNotification;

  var promiseTransaction = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(transactionPromise) {
      var _a, _b, _c, _d, _e, _f, transaction, receipt, errorMessage, droppedAndReplaced, status, type;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (chainId) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              transaction = undefined;
              _context.prev = 3;
              _context.next = 6;
              return transactionPromise;

            case 6:
              transaction = _context.sent;
              setState({
                transaction: transaction,
                status: 'Mining',
                chainId: chainId
              });
              addTransaction({
                transaction: Object.assign(Object.assign({}, transaction), {
                  chainId: chainId
                }),
                submittedAt: Date.now(),
                transactionName: options === null || options === void 0 ? void 0 : options.transactionName
              });
              _context.next = 11;
              return transaction.wait();

            case 11:
              receipt = _context.sent;
              setState({
                receipt: receipt,
                transaction: transaction,
                status: 'Success',
                chainId: chainId
              });
              return _context.abrupt("return", receipt);

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](3);
              errorMessage = (_e = (_c = (_b = (_a = _context.t0.error) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : _context.t0.reason) !== null && _c !== void 0 ? _c : (_d = _context.t0.data) === null || _d === void 0 ? void 0 : _d.message) !== null && _e !== void 0 ? _e : _context.t0.message;

              if (transaction) {
                droppedAndReplaced = isDroppedAndReplaced(_context.t0);

                if (droppedAndReplaced) {
                  status = _context.t0.receipt.status === 0 ? 'Fail' : 'Success';
                  type = status === 'Fail' ? 'transactionFailed' : 'transactionSucceed';
                  addNotification({
                    notification: {
                      type: type,
                      submittedAt: Date.now(),
                      transaction: _context.t0.replacement,
                      receipt: _context.t0.receipt,
                      transactionName: (_f = _context.t0.replacement) === null || _f === void 0 ? void 0 : _f.transactionName,
                      originalTransaction: transaction
                    },
                    chainId: chainId
                  });
                  setState({
                    status: status,
                    transaction: _context.t0.replacement,
                    originalTransaction: transaction,
                    receipt: _context.t0.receipt,
                    errorMessage: errorMessage,
                    chainId: chainId
                  });
                } else {
                  setState({
                    status: 'Fail',
                    transaction: transaction,
                    receipt: _context.t0.receipt,
                    errorMessage: errorMessage,
                    chainId: chainId
                  });
                }
              } else {
                setState({
                  status: 'Exception',
                  errorMessage: errorMessage,
                  chainId: chainId
                });
              }

              return _context.abrupt("return", undefined);

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 16]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [chainId, setState, addTransaction, options]);
  return {
    promiseTransaction: promiseTransaction,
    state: state
  };
}